import type { TenantSubscription, TenantSubscriptionBase } from "../../../types/admin";
import { createAdminBaseService } from "./adminBaseService";

const base = createAdminBaseService<TenantSubscription, TenantSubscriptionBase>({
  tableName: "tenant_subscriptions",
  searchColumns: ["billing_email"],
});

export class AdminSubscriptionService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
